import * as APIClient from './APIClient';

export const fetch = async () => {
  const response = await APIClient.get('/v1/coupon_customers/');
  return response.json();
};

export const create = referralCode =>
  APIClient.post('/v1/coupon_customers/', { referral_code: referralCode });
